module.exports = __webpack_public_path__ + "static/explore-learning-3b4c1decf58c8e6946ee743667211e02.jpg";